module.exports = __webpack_public_path__ + "img/login_view.e29ba710.jpeg";